/* One-page print sheet for the cellar quote.
 *
 * Printing the live page produced four pages of announcement bar, header,
 * footer and Shopify's own preview bar. Rather than fight that with selectors,
 * this builds a self-contained sheet, appends it to <body>, and the print CSS
 * in wcc-quote.css hides every other body child outright.
 *
 * The sheet is dated and says plainly that it is not a held price, because a
 * contractor may hand it to a client and it may be read months later.
 */
(function (root) {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
  /* The page restamps its BTU figure with the full heat-load total from
   * wcc-load-detail. Carry the same number here, or this output contradicts
   * the page it came from. Falls back to the old estimate when the detail
   * snippet is not on the page. */
  function loadBtu(q) {
    try {
      if (typeof root.WCCLoadTotal === 'function') {
        var t = root.WCCLoadTotal();
        if (t != null && isFinite(t)) return Math.round(t);
      }
    } catch (e) {}
    return (q && q.btu) || 0;
  }

  function build(o) {
    var q = o.quote, i = o.input, d = o.data, lines = o.lines, url = o.url;
    var host = document.querySelector('.wcc-sheet');
    if (host) host.remove();
    host = document.createElement('div');
    host.className = 'wcc-sheet';

    var when = new Date().toLocaleDateString('en-US',
      { year: 'numeric', month: 'long', day: 'numeric' });

    var h = '';
    h += '<div class="wcc-sheet-hd">';
    if (d.logo) h += '<img src="' + esc(d.logo) + '" alt="">';
    h += '<h1>Cellar Cooling Quote</h1>';
    h += '<div class="meta">' + esc(d.shop || '') + '<br>' + esc(d.phone || '') +
         '<br>' + esc(when) + '</div>';
    h += '</div>';

    if (i.preparedFor || i.jobRef) {
      h += '<h2>Job</h2><div class="wcc-sheet-job">';
      if (i.preparedFor) h += '<div><b>Prepared for</b>' + esc(i.preparedFor) + '</div>';
      if (i.jobRef) h += '<div><b>Reference</b>' + esc(i.jobRef) + '</div>';
      h += '<div><b>Date</b>' + esc(when) + '</div>';
      h += '</div>';
    }

    h += '<h2>Cellar</h2><div class="wcc-sheet-room">';
    h += '<div><b>Dimensions</b>' + i.length + ' x ' + i.width + ' x ' + i.height + ' ft</div>';
    h += '<div><b>Room volume</b>' + q.volume.toLocaleString() + ' cu ft</div>';
    h += '<div><b>Sizing volume</b>' + q.sizingVolume.toLocaleString() + ' cu ft</div>';
    h += '<div><b>Est. load</b>~' + loadBtu(q).toLocaleString() + ' BTU/hr</div>';
    h += '</div>';
    if (q.allowances.length) {
      h += '<p class="wcc-sheet-note">Allowances we added: ' + esc(q.allowances.join('; ')) +
           '. Ours, not the manufacturer’s.</p>';
    }

    h += '<h2>Quoted</h2>';
    var total = 0;
    lines.forEach(function (l) {
      total += l.total;
      h += '<div class="wcc-sheet-line"><div><div class="n">' + esc(l.name) +
           (l.qty > 1 ? ' &times; ' + l.qty : '') + '</div><div class="d">' + esc(l.detail) +
           '</div></div><div>' + money(l.total) + '</div></div>';
    });
    h += '<div class="wcc-sheet-total"><span>Total</span><span>' + money(total) + '</span></div>';

    h += '<div class="wcc-sheet-foot">';
    if (url && root.WCCQR) {
      try { h += root.WCCQR.toSvg(url, { label: 'Cart link' }); } catch (e) {}
    }
    h += '<div class="t"><strong>Scan to load this cart.</strong><br>' +
         '<strong>Priced ' + esc(when) + '. This is not a held price.</strong><br>' +
         'Prices and stock move. Check both before you order.<br>' +
         'Questions: ' + esc(d.phone || '') + ', ' + esc(d.hours || '') +
         '<div class="u">' + esc(url || '') + '</div></div>';
    h += '</div>';

    h += '<p class="wcc-sheet-note">We size equipment against the capacity each manufacturer ' +
         'publishes, not against the load estimate above. That estimate is for orientation ' +
         'and is not a contractor-grade load calculation. Undersizing a cooling system can ' +
         'shorten its life, so call before ordering if the room has glass walls, stone or ' +
         'concrete, or an exhaust side that runs above 85F.</p>';

    host.innerHTML = h;
    document.body.appendChild(host);
    return host;
  }

  root.WCCQuoteSheet = { build: build };
})(window);
